export const OSM_DATA_PROVIDER_DOCUMENTATION = 'https://wiki.openstreetmap.org/wiki/Overpass_API/Overpass_QL#Settings';
